<template>
  <div class="mortgage">
    <UiModal
        name="request"
        :is-active="modal.active"
        @close="onModalRequestClose"
    >
      <template v-slot:top>Отправить заявку</template>
      <template v-slot:bottom>
        <template v-if="!modal.success">
          <form class="modal-forms" :class="{'modal-form_request': modal.isRequest}" @submit.prevent.stop="onSendRequest">
            <div class="modal-error" v-if="modal.error" v-html="modal.error"></div>
            <div class="modal-row" v-if="Object.keys(selectedOffer).length">
              <label>Банк</label>
              <input type="text" name="bankName" :value="selectedOffer.bankName" disabled class="modal-input">
            </div>
            <div class="modal-row">
              <label>ФИО<sup>*</sup></label>
              <input type="text" name="fio" v-model="modal.form.fio" class="modal-input">
            </div>
            <div class="modal-row">
              <label>Телефон<sup>*</sup></label>
              <imask-input
                  v-model="modal.form.phone"
                  :mask="'+{7} (000) 000-00-00'"
                  class="modal-input"
                  :lazy="false"
                  placeholder="+7(123)456-78-90"
                  name="phone"
              ></imask-input>
            </div>
            <div class="modal-row">
              <label>Email<sup>*</sup></label>
              <input type="text" name="email" v-model="modal.form.email" class="modal-input">
            </div>
            <div class="modal-row">
              <button type="submit" class="modal-button">Отправить</button>
            </div>
          </form>
        </template>
        <template v-else>
          {{ modal.success }}
        </template>
      </template>
    </UiModal>
    <h2 class="mort_heading">
      Подбор ипотеки
    </h2>
    <div class="mort__top">
      <div class="mort-offers-tabs__list">
        <span class="mort-offers-tabs__item"
              :class="{'active': curSelect === item.value}"
              v-for="item in selected"
              @click.prevent.stop="onChangeSelect(item)"
        >
          {{ item.label }}
        </span>
      </div>
      <div class="mortgage__form">
        <div class="mort-calc__list">
          <div class="mort-calc__item">
            <div class="mort-calc-input__holder">
              <imask-input
                  type="text"
                  class="mort-calc__input"
                  placeholder="Введите стоимость недвижимости"
                  v-model="form.objectCost.value"
                  :mask="'num ₽'"
                  :blocks="{num: {mask: Number, thousandsSeparator: ' '}}"
                  :min="0"
                  :lazy="false"
                  :unmask="true"
                  @accept="fetchOffer"
              ></imask-input>
              <div class="mort-calc-input__placeholder">
                Стоимость недвижимости
              </div>
            </div>
          </div>
          <div class="mort-calc__item">
            <div class="mort-calc-input__holder">
              <imask-input
                  type="text"
                  class="mort-calc__input"
                  placeholder="Введите первоначальный взнос"
                  v-model="form.initialPrice.value"
                  :mask="'num ₽'"
                  :blocks="{num: {mask: Number, thousandsSeparator: ' '}}"
                  :min="0"
                  :lazy="false"
                  :unmask="true"
                  @accept="fetchOffer"
              ></imask-input>
              <div class="mort-calc-input__placeholder">
                Первоначальный взнос
              </div>
              <div class="mort-calc-val__percent">
                {{ getPercent }}%
              </div>
            </div>
          </div>
          <div class="mort-calc__item">
            <div class="mort-calc-input__holder">
              <imask-input
                  type="text"
                  class="mort-calc__input"
                  placeholder="Введите срок кредита"
                  v-model="form.loanPeriod.value"
                  :unmask="true"
                  :mask="'num лет'"
                  :blocks="{num: {mask: Number, min: 1, max: 30}}"
                  :lazy="false"
                  :min="0"
                  @accept="fetchOffer"
              ></imask-input>
              <div class="mort-calc-input__placeholder">
                Срок кредита
              </div>
            </div>
          </div>
          <a class="mort-calc__item mort-calc__btn" @click.prevent.stop="onModalRequest">
            ЗАПРОС НА ПОЛУЧЕНИЕ ИПОТЕКИ
          </a>
          <div class="mort-calc__txt">
            Это предварительные предложения банков, носит информационный характер. Не оферта. Подробности по программам необходимо уточнять по телефону или офисе продаж "Южная долина"
          </div>
        </div>
      </div>
    </div>
    <div class="mort__bottom">
      <p class="no__offers" v-if="!list.length && !isRequest">
        Предложений не найдено. <br>
        Попробуйте изменить первоначальный взнос, <br> срок кредита или тип ипотеки
      </p>
      <div class="mort-offers__list" :class="{'mort-offers__load': isRequest}" v-if="list.length > 0">
        <div class="mort-offers__item"
             v-for="item in list"
             :key="item.id"
             :class="{'mort-offers__item-select': Object.keys(selectedOffer).length && selectedOffer.id === item.id}"
             @click.prevent.stop="onSelectBankOffer(item)"
        >
          <div class="mort-offers-item__inner">
            <div class="mort-offer__logo">
              <img :src="item.bankLogo" :alt="item.bankName">
            </div>
            <div class="mort-offer__info">
              <div class="mort-offer-info__top">
                <div class="mort-offer-info__left mort-offer__text">
                  <div class="mort-offer__title" v-html="item.bankName"></div>
                  <div class="mort-offer__description" v-html="item.name"></div>
                </div>
                <div class=" mort-offer__month mort-offer-info__right">
                  <span>{{ getPeriod(item) }}</span> ₽/мес
                </div>
              </div>
              <div class="mort-offer-info__bottom">
                <div class="mort-offer-info__left mort-offer__full">
                  Полная стоимость кредита <span>{{ item.totalLoanCostLowerLimit }}—{{ item.totalLoanCostUpperLimit }}</span>%
                </div>
                <div class="mort-offer__percent mort-offer-info__right">
                  под <span>{{ item.rate }}</span>%
                </div>
              </div>
            </div>
          </div>
        </div>
        <span class="more-items__link" v-if="storeList.length > 0" @click.prevent.stop="onLoadMore">
          +<span>{{ storeList.length }}</span> предложений
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { IMaskComponent } from 'vue-imask'

import { UiModal } from '@/components/UI'

export default {
  name: 'CalculatorComponent',

  components: {
    'imask-input': IMaskComponent,
    UiModal
  },

  data () {
    return {
      isRequest: false,

      modal: {
        isRequest: false,

        success: false,

        active: false,

        error: false,

        form: {
          fio: '',
          phone: '',
          email: ''
        }
      },

      selected: [
        {
          label: 'Стандартная',
          value: 'STANDARD',
          percent: 15.1
        },
        {
          label: 'Семейная',
          value: 'FAMILY',
          percent: 20.1
        },
        {
          label: 'Военная',
          value: 'MILITARY',
          percent: 30.1,
          loanPeriod: '20'
        },
        {
          label: 'ИТ',
          value: 'IT',
          percent: 20.1
        }
      ],

      curSelect: 'FAMILY',

      form: {
        objectCost: {
          value: '5000000'
        },
        initialPrice: {
          value: '1000000'
        },
        loanPeriod: {
          value: '20'
        }
      },

      list: [],

      selectedOffer: {},

      storeList: []
    }
  },

  computed: {
    getPercent() {
      const roundedNumber = ((this.form.initialPrice.value / this.form.objectCost.value) * 100).toFixed(2);

      const roundedNumberAsNumber = parseFloat(roundedNumber);

      return  roundedNumberAsNumber.toString();
    }
  },

  mounted() {
    if (typeof calculatorObjectCost !== 'undefined') {
      this.form.objectCost.value = calculatorObjectCost.toString();

      this.form.initialPrice.value = ((parseInt(this.form.objectCost.value) * this.selected[1].percent) / 100).toString();
    }

    if (typeof calculatorLoanPeriod !== 'undefined') {
      this.form.loanPeriod.value = calculatorLoanPeriod.toString();
    }

    this.fetchOffer()
  },

  methods: {
    onSendRequest() {
      if (this.modal.isRequest) {
        return false;
      }

      this.modal.error = false;
      this.modal.success = false;
      let isValid = true;

      for (const key in this.modal.form) {
        if (!this.modal.form[key].trim()) {
          isValid = false;

          break;
        }
      }

      if (!isValid) {
        this.modal.error = 'Заполните все обязательные поля!';

        return false;
      }

      this.modal.isRequest = true;

      let formData = new FormData();

      formData.append('fio', this.modal.form.fio);
      formData.append('price_flat', this.form.objectCost.value);
      formData.append('sum', this.form.initialPrice.value);

      if (Object.keys(this.selectedOffer).length) {
        formData.append('bank', this.selectedOffer.bankName);
      }

      formData.append('phone', this.modal.form.phone);
      formData.append('email', this.modal.form.email);
      formData.append('Submit', 'Отправить');



      axios
          .post('/ajax/form-mortgage/', formData)
          .then((response) => {
            this.modal.isRequest = false;

            yaCounter21300661.reachGoal('CALL_ORDER');
            yaCounter21300661.reachGoal('send_callback');
            ga('send', 'event', 'callback', 'send');

            this.modal.success = 'Заявка отправлена. Наш менеджер свяжется с Вами в ближайшее время.';
          })
    },

    onModalRequestClose() {
      this.modal.active = false;
      this.modal.error = false;
      this.modal.success = false;

      for (const key in this.modal.form) {
        this.modal.form[key] = '';
      }
    },

    onModalRequest() {
      this.modal.active = true;

      yaCounter21300661.reachGoal('open_callback');
      ga('send', 'event', 'callback', 'open');
    },

    onSelectBankOffer(item) {
      if (Object.keys(this.selectedOffer).length > 0 && this.selectedOffer.id === item.id) {
        this.selectedOffer = {};
      } else {
        this.selectedOffer = item;
      }
    },

    getPeriod(item) {
      const period = item.periods.find((period) => period.period === (this.form.loanPeriod.value * 12));

      if (period) {
        return (Math.ceil(period.amount / 100)).toLocaleString('ru-RU');
      }

      return '';
    },

    onChangeSelect(item) {
      if (this.curSelect === item.value) {
        return false;
      }

      this.curSelect = item.value;
      this.$set(this.form.initialPrice, 'value', ((parseInt(this.form.objectCost.value) / 100) * item.percent).toString());

      if (typeof item.loanPeriod !== 'undefined') {
        this.$set(this.form.loanPeriod, 'value', item.loanPeriod.toString());
      } else if (typeof calculatorLoanPeriod !== 'undefined') {
        this.$set(this.form.loanPeriod, 'value', calculatorLoanPeriod.toString());
      }

      this.fetchOffer();
    },

    onLoadMore() {
      this.list = [...this.list, ...this.storeList];

      this.storeList = [];
    },

    fetchOffer () {
      const loanPeriod = {...this.form.loanPeriod};
      const initialPrice = {...this.form.initialPrice};
      const objectCost = {...this.form.objectCost};

      this.selectedOffer = {};

      if (loanPeriod.value == '' || initialPrice.value == '' || objectCost.value == '') {
        this.list = [];
        this.storeList = [];

        return false;
      }

      this.isRequest = true;

      const options = {
        method: 'POST',
        url: 'https://gql.make.dvizh.io/gql',
        headers: {
          'content-type': 'application/json'
        },
        data: {
          query: `
            query {
              getLoanOffer(
                loanPeriod: ${parseInt(loanPeriod.value)},
                loanTypes: PRIMARY,
                propertyTypes: FLAT,
                housingComplexUuids: ["8def77a7-a8b7-433f-8c41-c07e6c664aa8"],
                initialPayment: ${parseInt(initialPrice.value) * 100},
                cost: ${parseInt(objectCost.value) * 100},
                mortgageType: ${this.curSelect},
                employmentType: employee,
                proofOfIncome: ndfl,
                lastJobExp: 36,
                overallExp: 120,
                isRfCitizen: true,
                age: 28,
                isInsured: true
              ) {
                id,
                name,
                bankId,
                bankName,
                bankLogo,
                rate,
                recommendedIncomeCoeff,
                periods {
                  period,
                  amount
                },
                minInitialPayment,
                maxCreditPeriod,
                maxCreditAmount,
                minOverallExp,
                minAge,
                minLastJobExp,
                maxAge,
                strictlyMatchesLoanPeriod,
                totalLoanCostLowerLimit,
                totalLoanCostUpperLimit,
                periodParams {
                  months,
                  rate,
                  monthlyPayment
                }
              }
            }
          `
        }
      }

      axios
        .request(options)
        .then((response) => {
          this.list = [];
          this.storeList = [];

          this.isRequest = false

          if (typeof response.data.data !== 'undefined') {
            let res = response.data.data.getLoanOffer

            if (res.length > 0) {
              let list = []

              res.forEach((item) => {
                if (typeof list[item.bankId] === 'undefined') {
                  list[item.bankId] = []
                }

                list[item.bankId].push(item)
              })

              let listRes = [];

              for (const key in list) {
                const minRateObject = list[key].reduce((min, current) => {
                  return current.rate < min.rate ? current : min;
                });

                listRes.push(minRateObject);
              }

              listRes.sort((a, b) => a.totalLoanCostLowerLimit - b.totalLoanCostLowerLimit);

              let first = listRes.slice(0, 5);

              listRes.splice(0, 5);

              this.list = first;
              this.storeList = listRes;
            }
          }
        })
    }
  }
}
</script>
